import { MemberShipChangePayload } from '@core/dto';
import { AuthAdapter } from '@core/adapters';

export class MembershipChangeUseCase {
  constructor(private readonly authAdapter: AuthAdapter) {}
  async execute(payload: MemberShipChangePayload): Promise<void> {
    await this.authAdapter.membershipChange(payload);
  }
}
